import { Box, SelectChangeEvent, SelectField } from '@color/continuum';
import { useState } from 'react';

const STORAGE_KEY = 'variant_classifications_auto_refresh';

export enum AutoRefreshInterval {
  Off = 0,
  TenSeconds = 10000,
  TwentySeconds = 20000,
  ThirtySeconds = 30000,
  SixtySeconds = 60000,
}

export const AUTO_REFRESH_INTERVAL_OPTIONS = [
  { label: '10 sec', value: AutoRefreshInterval.TenSeconds },
  { label: '20 sec', value: AutoRefreshInterval.TwentySeconds },
  { label: '30 sec', value: AutoRefreshInterval.ThirtySeconds },
  { label: '60 sec', value: AutoRefreshInterval.SixtySeconds },
];

type AutoRefreshState = {
  interval: AutoRefreshInterval;
  setInterval: (value: AutoRefreshInterval) => void;
};

export function useAutoRefreshState(): AutoRefreshState {
  const [interval, setInterval] = useState<AutoRefreshInterval>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? JSON.parse(stored) : AutoRefreshInterval.Off;
  });

  const setAndStoreInterval = (value: AutoRefreshInterval) => {
    setInterval(value);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  };

  return {
    interval,
    setInterval: setAndStoreInterval,
  };
}

export const AutoRefreshSelect = ({ autoRefreshState }: { autoRefreshState: AutoRefreshState }) => {
  const { interval, setInterval } = autoRefreshState;

  return (
    <Box sx={{ minWidth: 140 }}>
      <SelectField
        label="Auto refresh"
        options={AUTO_REFRESH_INTERVAL_OPTIONS}
        value={interval}
        onChange={(event: SelectChangeEvent<string>) =>
          setInterval(
            event.target.value !== ''
              ? (parseInt(event.target.value, 10) as AutoRefreshInterval)
              : AutoRefreshInterval.Off
          )
        }
        optionalIndicatorIsEnabled={false}
      />
    </Box>
  );
};
